import { observable, makeObservable, action } from 'mobx'

class TemplateCustomTagStore {
    @observable availableTags = []

    @observable recordTags = []

    @observable updating = true

    @observable isAccOpen = {}

    useLocalSave = false

    constructor(appStore, exposeUpdateBody, templateParams) {
        this.appStore = appStore
        this.templateParams = templateParams
        makeObservable(this)
        if (typeof exposeUpdateBody === 'function') {
            this.useLocalSave = true
            exposeUpdateBody(this.updateTemplateCustomTags)
        }
    }

    @action
    init = async () => {
        this.updating = true
        this.availableTags = await this.appStore.getAvailableTagsTemplate(this.templateParams)
        await this.populateCheckboxFields()
        this.updating = false
    }

    @action
    populateCheckboxFields = async () => {
        const initState = await this.appStore.getRecordTags(7, this.appStore.survey.id, true)
        // no need to check questionType as templates only use SB and CH,
        // and they behave the same when applied to this template component
        this.recordTags = initState.map((tag) => ({
            tagId: tag.tagId,
            optionId: tag.optionId,
        }))
    }

    @action
    toggleCheckbox = (obj, e) => {
        const optionId = Number(e.target.getAttribute('valueid'))
        const { name: tagId, value } = obj
        const checkedOptionIdx = this.recordTags.findIndex((rt) => rt.tagId === tagId && rt.optionId === optionId)

        if (checkedOptionIdx > -1 && value === false) {
            this.recordTags.splice(checkedOptionIdx, 1)
        } else {
            this.recordTags.push({ tagId, optionId })
        }
    }

    @action
    expandCustomTag = (i) => {
        this.isAccOpen[i] = !this.isAccOpen[i]
    }

    formatUpdateBody = (tags) => {
        const seen = new Set()
        const sanitizedTags = tags.filter((tag) => {
            if (seen.has(tag.optionId)) return false
            seen.add(tag.optionId)
            return true
        })
        return sanitizedTags
    }

    updateTemplateCustomTags = async () => {
        this.updating = true
        const { saveTemplateTags, survey } = this.appStore
        const body = this.formatUpdateBody(this.recordTags)
        if (this.useLocalSave) {
            this.updating = false
            return body
        }

        await saveTemplateTags(survey.id, body)
        this.updating = false
    }
}

export default TemplateCustomTagStore
